import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'procure-confidential-icon',
  templateUrl: './confidential-icon.component.html',
  styleUrl: './confidential-icon.component.scss',
  imports: [MatIcon, MatTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfidentialIcon {
  readonly tooltip = input('Confidential');
}
